import Table from './Table';
export default Table;


//////////////////
// WEBPACK FOOTER
// /Users/shuai/Documents/github/ant-design-pro-site/scaffold/node_modules/_antd@3.15.2@antd/es/table/index.js
// module id = 798
// module chunks = 0